export default "__VITE_ASSET__59135fe5__"